export default {
  continue: 'Vil du fortsætte?',
  want_to_continue: 'Ønsker du at fortsætte?',
  are_you_sure_you_want_to_continue: 'Er du sikker på, at du vil fortsætte?',
  are_you_sure_you_want_to_continue_2: 'Er du sikker på, du ønsker at fortsætte?',
  unsaved_changes:
    'Sidst du ændrede denne sikre fil, var der ændringer der ikke blev gemt.<br/> Vil du fortsætte hvor du slap?',
  clear_everything_in_the_field: 'Du er ved at rydde alt i feltet.',
  remove_all_organizers_from_simple_event:
    'Du er ved at fjerne alle medarrangører fra begivenheden. Det betyder, at de ikke længere vil kunne se eller redigere i begivenheden.',
  remove_all_organizers_from_meeting_event:
    'Du er ved at fjerne alle medarrangører fra samtalen. Det betyder, at de ikke længere vil kunne se eller redigere i samtalen.',
  action_step_up_required: 'For at udføre denne handling skal du logge ind på et højere sikkerhedsniveau.',
  not_enough_seats:
    'Der er kun {remaining} ledige pladser tilbage. Du kan derfor ikke angive et antal, som er større end {remaining}.',
  missing_seat_selections: 'Du skal angive mindst en deltager for at deltage i begivenheden.',
  seats_full: 'Der er ingen ledige pladser.',
  last_sent_reminder_warning: 'Seneste rykker blev sendt {dateTime}',
  deleting_occurrence_1: 'Du er ved at slette en enkelt begivenhed i en serie af begivenheder.',
  deleting_occurrence_2: 'Er du sikker på, at du vil slette begivenheden?',
  deleting_series_1: 'Du er ved at slette en serie af begivenheder.',
  deleting_series_2: 'Er du sikker på, at du vil slette alle begivenhederne i serien?',
  deleting_others_event_1: 'Du er ved at slette en begivenhed, du ikke selv har oprettet.',
  deleting_others_event_2: 'Er du sikker på du vil fortsætte?',
  deleting_event: 'Er du sikker på, at du vil slette begivenheden?',
  confirm_assigning_slot: 'Er du sikker på, at du vil tilmelde personen til dette møde.',
  confirm_blocking_slot: 'Du er ved at blokere en tid, så deltagerne ikke kan vælge den.',
  respond_to_timeslot: 'Er du sikker på, at du vil flytte din tid til d. {startTime} - {endTime}',
  changes_saved: 'Dine ændringer er blevet gemt',
  decline_meeting_1:
    'Du er ved at afslå samtalen på vegne <strong>af alle barnets forældre/kontaktpersoner</strong>. Hvis du afslår samtalen, vil den forsvinde fra kalenderen for alle forældre/kontaktpersoner. Herefter kan der ikke vælges en anden tid for samtalen.',
  decline_meeting_2: 'Er du sikker på, at du vil afslå samtalen?',
  not_enough_seats_for_everyone: 'Vær opmærksom på, at der ikke er nok tider til alle.',
  download_album: 'Er du sikker på, at du vil fortsætte?',
  download_album_single: 'Du er ved at downloade albummet <strong>{name}</strong>.',
  download_album_multiple: 'Du er ved at downloade albummerne:',
  delete_album_1:
    'Hvis du sletter {album}, vil {the} også blive <strong>slettet for alle dem, {the} er delt med</strong>. Alle medier i {album} slettes ligeledes.',
  delete_album_2: 'Er du sikker på, at du vil slette {album}?',
  delete_album_single: 'Du er ved at slette albummet <strong>{name}</strong>.',
  delete_album_multiple: 'Du er ved at slette albummerne:',
  success_esdh_export: 'De valgte filer sendes til {systemName}.',
  unsaved_change: 'Ændringer vil ikke blive gemt.',
  confirm_leaving: 'Er du sikker på, du vil forlade siden?',
  notification_clearance: 'Du er ved at ryde ALLE notifikationer for de valgte områder.',
  reported_content_too_short: 'Du skal skrive en begrundelse på minimum 10 tegn.',
  discard_changes_warning: 'Vil du fortsætte og slette dine ændringer?',
  view_sensitive_results: 'For at se søgeresultater med følsomme data:',
  login_with_higher_level: 'Log ind på højere sikkerhedsniveau',
  module_locked:
    'Moduler markeret med en rød prik er siden dit sidste besøg låst eller oplåst af kommunal administrator.',
  confirm_continue: 'Er du sikker på at du vil fortsætte?',
  discard_widgets_on_module:
    'Du er ved at fjerne {module}, hvor {widgets} er placeret.<br/> Hvis du fjerner {module}, sletter du også denne widget.<br/><br/> @:warning.are_you_sure_you_want_to_continue_2 ' +
    '| Du er ved at fjerne {module}, hvor {widgets} er placeret.<br/> Hvis du fjerner {module}, sletter du også disse widgets.<br/><br/> @:warning.are_you_sure_you_want_to_continue_2',
  clear_all: 'Du er ved at rydde alt i feltet.<br/><br/> Ønsker du at fortsætte?',
  no_matched_data: 'Ingen matchende data',
  no_data: 'Ingen data',
  limit_number_of_characters: 'Beskrivelsen må ikke være over {limit} karakterer',
};
